const nonDNATypes = {

  "SmallMolecule": "molecule",
  "Protein": "protein",
  "Dna": "dna",
  "Rna": "rna",
  "Complex": "complex"
};

module.exports = nonDNATypes;
